define(['./NavBarCtrl'], NavBarCtrl => {
    return function () {
        return {
            restrict: 'EA',
            template: '<div ng-transclude></div>',
            transclude: true,
            controller: NavBarCtrl
        };
    };
});


// WEBPACK FOOTER //
// ./app/js/portal/directives/NavBarDirective.js